
            const data = {"name":"chevron-with-paddings","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.293 19.707a1 1 0 0 1 0-1.414L14.586 12 8.293 5.707a1 1 0 0 1 1.414-1.414l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414 0Z\" _fill=\"#81889B\"/>","originalColors":[{"type":"fill","color":"#81889B"}],"stopColors":[]}}
        
                    module.exports = data
                    